<template>
  <b-form>
    <BaseModal name="upcoming-invoices-export" size="lg" :title="$t('seller.sales.text_2613')" @shown="openModal">
      <b-row v-if="!loading">
        <b-col cols="12">
          <b-row>
            <b-col>
              <b-form-group :label="$t('seller.sales.text_2622')">
                <b-input-group>
                  <template #prepend>
                    <b-input-group-text class="input-icon">
                      <font-awesome-icon icon="envelope" class="icon-gray" />
                    </b-input-group-text>
                  </template>
                  <b-form-input
                    id="email"
                    name="email"
                    v-model="email" 
                    type="text"
                    class="email-input"
                    placeholder="user@voomp.com.br"
                    v-validate="'required|email'"
                  ></b-form-input>
                  <b-form-invalid-feedback
                    :state="!errors.has('email')"
                  >
                    Digite um e-mail válido
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <template v-slot:footer="{ cancel }">
        <BaseButton variant="link-info" class="mr-4" @click="cancel">
          {{ $t('seller.sales.text_2624') }}
        </BaseButton>
        <BaseButton ref="button" @click="onSubmit" variant="black" :disabled="errors.has('email') || loading">
          {{ $t('seller.sales.text_2625') }}
        </BaseButton>
      </template>
        
      <div class="d-flex justify-content-center" v-if="loading">
        <b-spinner label="Loading..."></b-spinner>
      </div>
      <span v-if="note" style="color: #666;">
        {{ note }}
      </span>
    </BaseModal>
    </b-form>
  </template>
  <script>
  import Multiselect from "vue-multiselect";
  
  import UpcomingInvoicesService from "@/services/resources/UpcomingInvoicesService";
  const upcomingInvoicesService = UpcomingInvoicesService.build();
  
  export default {
    props: {
      filters: {
        type: Object,
        default: () => ({}),
      },
      type: {
        type: String,
        default: 'export',
      },
      note: {
        type: String,
        default: '',
      },
    },
    components: {
      Multiselect,
    },
    data() {
      return {
        email: "",
        loading: false,
      };
    },
    methods: {
      async onSubmit() {
        try {
          const valid = await this.$validator.validate('email');

          if (!valid) {
            return;
          }

          this.loading = true;

          let data = {
            id: '/export',
            email: this.email,
            ...this.filters
          };

          let response = {};
    
          if (this.type === 'details') {
            response = await upcomingInvoicesService.exportDetails(data)
          } else {
            response = await upcomingInvoicesService.export(data)
          }

          this.$bvToast.toast(
            response.message ? this.$t('seller.sales.wait_for_running_export_to_finish') : this.$t('seller.sales.text_2626'),
            {
              title: this.$t('seller.sales.text_2613'),
              variant: 'info',
              autoHideDelay: 5000,
              appendToast: true,
            }
          );
          this.$bvModal.hide('upcoming-invoices-export');
        } catch (err) {
          console.log(err);
          this.$bvToast.toast(this.$t('seller.sales.text_2831'), {
            title: this.$t('seller.sales.text_2613'),
            variant: 'danger',
            autoHideDelay: 5000,
            appendToast: true,
          });
        } finally {
          this.loading = false;
        }
      },
      openModal() {
        this.email = this.$store.getters.getProfile.email;
      },
    },
    mounted() { },
  };
  </script>
  
  <style scoped>
  .email-input {
    border-left-width: 0;
    margin: 0;
    border-radius: 0 3px 3px 0 !important;
  }
  
  .email-input:hover,
  .email-input:focus {
    border-color: #ededf0 !important;
  }
  
  .input-icon {
    background-color: #fff;
    border: 1px solid #ededf0;
    border-right: 0;
    margin: 0;
    padding-right: 1px;
    border-radius: 3px 0 0 3px;
    color: #495057;
  }
  </style>
  